import { useState } from 'react';
import { CommunitySheet } from './CommunitySheet';

/**
 * Header'da Topluluk menüsünü açan kupa chip'i.
 * Tıklanınca alttan sheet açılır (Liderlik / Arkadaşlar / Turnuvalar / Davet).
 * Her kullanıcı için görünür (giriş gerekmez).
 */
export function TrophyChip() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className="trophy-chip"
        title="Topluluk"
        aria-label="Topluluk"
        onClick={() => setOpen(true)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: 999,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--text-secondary)',
          transition: 'background 0.15s, color 0.15s',
        }}
        onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = 'var(--btn-secondary)'; (e.currentTarget as HTMLButtonElement).style.color = 'var(--text-primary)'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = 'transparent'; (e.currentTarget as HTMLButtonElement).style.color = 'var(--text-secondary)'; }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M8 21h8" />
          <path d="M12 17v4" />
          <path d="M7 4h10v5a5 5 0 0 1-10 0z" />
          <path d="M7 6H4v3a3 3 0 0 0 3 3" />
          <path d="M17 6h3v3a3 3 0 0 1-3 3" />
        </svg>
      </button>
      <CommunitySheet open={open} onClose={() => setOpen(false)} />
    </>
  );
}
